import React, { memo, useEffect } from 'react';
import queryString from 'query-string';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

interface IProps {
    isDashManifestVideo: boolean;
    setAudioAction: (action: 'add' | 'remove' | 'none') => void;
}

export default memo(function AudioAction({ isDashManifestVideo, setAudioAction }: IProps) {
    const [value, setValue] = React.useState<'add' | 'remove' | 'none'>(isDashManifestVideo ? 'add' : 'none');

    useEffect(() => {
        if(isDashManifestVideo === true){
            setValue('add');
        }else if(isDashManifestVideo === false){
            setValue('none');
        }
    }, [isDashManifestVideo])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const action = event.target.value as 'add' | 'remove' | 'none';
        setValue(action);
        setAudioAction(action);
    };

    return (
        <Grid item xs={12}>
            <Box display='flex' justifyContent='center' m={3}>
                <FormControl component='fieldset'>
                    <Box display='flex' justifyContent='center'>
                        <FormLabel component='legend'>Audio</FormLabel>
                    </Box>
                    <RadioGroup
                        row
                        aria-label='action'
                        name='action'
                        value={value}
                        onChange={handleChange}
                    >
                        <FormControlLabel
                            value='add'
                            control={<Radio />}
                            label='Add'
                        />
                        <FormControlLabel
                            value='remove'
                            control={<Radio />}
                            label='Remove'
                        />
                        <FormControlLabel
                            value='none'
                            control={<Radio />}
                            label='None'
                        />
                    </RadioGroup>
                </FormControl>
            </Box>
        </Grid>
    );
});
